import React from "react";
import "./FormInputs.css";

/** Single-line text/email input. Pass any native <input> prop through. */
export function TextInput({ label, ...props }) {
  return (
    <label className="mihu-field">
      {label && <span className="mihu-field-label">{label}</span>}
      <input className="mihu-input" {...props} />
    </label>
  );
}

/** Native <select> wrapper, e.g. role picker (Artist / Engineer / Listener). */
export function SelectInput({ label, options = [], ...props }) {
  return (
    <label className="mihu-field">
      {label && <span className="mihu-field-label">{label}</span>}
      <select className="mihu-input" {...props}>
        {options.map((opt) => (
          <option key={opt.value ?? opt} value={opt.value ?? opt}>
            {opt.label ?? opt}
          </option>
        ))}
      </select>
    </label>
  );
}

/** Inline input + button pair, e.g. newsletter signup. */
export function InlineForm({
  placeholder = "your@email.com",
  buttonLabel = "Subscribe",
  onSubmit,
  type = "email",
}) {
  return (
    <form
      className="mihu-inline-form"
      onSubmit={(e) => {
        e.preventDefault();
        const value = e.target.elements.inlineInput.value;
        onSubmit && onSubmit(value);
      }}
    >
      <input
        name="inlineInput"
        className="mihu-input mihu-inline-input"
        type={type}
        placeholder={placeholder}
        required
      />
      <button type="submit" className="mihu-inline-btn">
        {buttonLabel}
      </button>
    </form>
  );
}
